import React from "react"
import { push } from "connected-react-router"
import { values, sortBy } from "lodash"
import { connect } from "react-redux"
import { Search } from "react-feather"
import Cookies from 'js-cookie'

import { Footer, FooterText, FooterLinks, FooterLink } from "react-weui"

import CoolPage from "../components/CoolPage"
import CitySelector from "../components/CitySelector"
import { cities } from "../../../../data"
import { getSelections } from "../selectors"

import "./WelcomePage.less"

/**
 *
 */

function WelcomePage(props) {
  const gotoSearch = tag => () => props.goto(`/catalogo/search?tag=${tag}`)
  return (
    <CoolPage
      title={
        <img src="/static/logo_outline_white.svg" style={{ height: "1em", marginRight: 5 }} />
      }
      isChevron={!!Cookies.get('tepaRoom')}
      containerProps={{ className: "wp2" }}
      className="wp2-page"
      withSearchButton
      gotoSearch={gotoSearch()}
    >
      <h1>选择参观的城市</h1>
    
      <CitySelector />

      <Footer>
        <FooterLinks>
          <FooterLink href="http://www.chinespain.cn">By ChineSpain</FooterLink>
          <FooterLink href="/catalogo/tos">Términos y Condiciones</FooterLink>
        </FooterLinks>
        <FooterText>Copyright &copy; 2018-2019 Approaching Cultures</FooterText>
      </Footer>
    </CoolPage>
  )
}

const mapStateToProps = (_state, _ownProps) => ({})

const mapDispatchToProps = dispatch => ({
  goto: url => dispatch(push(url))
})

export default connect(mapStateToProps, mapDispatchToProps)(WelcomePage)



// WEBPACK FOOTER //
// ./src/app/catalogo/pages/WelcomePage.jsx